if (!customElements.get("collection-filters")) {
  class CollectionFilters extends HTMLElement {
    constructor() {
      super();

      this.handleToggleRef = this.handleToggle.bind(this);
      this.handleChangeRef = this.handleChange.bind(this);
      this.handleInputRef = this.handleInput.bind(this);
      this.handleResizeRef = this.handleResize.bind(this);
      this.handleClearFiltersRef = this.handleClearFilters.bind(this);
    }

    handleToggle(event) {
      this.classList.toggle("is-open");
    }

    handleChange(event) {
      if (this.priceMinInput && this.priceMaxInput) {
        if (
          this.priceMaxInput.value != "" &&
          Number(this.priceMaxInput.value) < Number(this.priceMinInput.value)
        ) {
          return;
        }
      }

      const form = event.target.closest("form");
      this.submitForm(form);
    }

    handleInput(event) {
      if (this.debounceTimer) return;

      this.debounceTimer = setTimeout(() => {
        this.handleChange(event);
      }, 200);
    }

    handleResize() {
      let offset = window.innerHeight;

      this.offsetItems.forEach((item) => {
        offset -= item.scrollHeight;
      });

      this.style.setProperty("--filter-body-max-height", offset + "px");
    }

    handleBreakpoint() {
      this.classList.toggle("is-open", !this.breakpoint.matches);
    }

    handleClearFilters(event) {
      const form = this.querySelector("form");

      // Reset all input fields in the form
      form.querySelectorAll("input").forEach((input) => {
        if (input.type === "checkbox" || input.type === "radio") {
          input.checked = false; // Uncheck checkboxes and radio buttons
        } else if (input.type === "number") {
          input.value = ""; // Clear number inputs
        }
      });

      // Submit the cleared form
      this.submitForm(form);
    }

    submitForm(form) {
      const url = new URL(window.location.href);

      // Remove stale filter params while preserving view, sort_by, etc.
      const keysToDelete = [...url.searchParams.keys()].filter((k) =>
        k.startsWith("filter.")
      );
      keysToDelete.forEach((k) => url.searchParams.delete(k));

      // Append new filter values from the form
      for (const [key, value] of new URLSearchParams(new FormData(form))) {
        url.searchParams.append(key, value);
      }

      const urlString = url.toString();

      fetch(urlString)
        .then((res) => res.text())
        .then((data) => {
          document.dispatchEvent(
            new CustomEvent("exo:update-collection-items", {
              detail: {
                id: this.getAttribute("data-id"),
                html: data,
              },
            })
          );

          history.replaceState({}, "", urlString);
        })
        .catch((err) => console.error(err));
    }

    disconnectedCallback() {
      document.removeEventListener("exo:toggle-filters", this.handleToggleRef);
      this.removeEventListener("change", this.handleChangeRef);
      window.removeEventListener("resize", this.handleResizeRef);
      document.removeEventListener("click", this.handleClearFiltersRef);
    }

    connectedCallback() {
      document.addEventListener("exo:toggle-filters", this.handleToggleRef);
      this.addEventListener("change", this.handleChangeRef);
      this.addEventListener("input", this.handleInputRef);
      window.addEventListener("resize", this.handleResizeRef);
      document.addEventListener("click", (event) => {
        if (event.target.matches("[data-clear-filters]")) {
          this.handleClearFilters(event);
        }
      });

      this.breakpoint = window.matchMedia("(max-width: 989px)");
      this.breakpoint.addEventListener(
        "change",
        this.handleBreakpoint.bind(this)
      );
      this.handleBreakpoint();

      this.offsetItems = this.querySelectorAll(".js-offset");

      this.handleResize();

      this.priceMinInput = this.querySelector("[data-price-min]");
      this.priceMaxInput = this.querySelector("[data-price-max]");
    }
  }

  customElements.define("collection-filters", CollectionFilters);
}
